export const ADMIN_JWT_STORAGE_KEY = "adminJwt";
export const ADMIN_AUTH_FLAG_KEY = "adminAuthed";

export function getAdminJwt() {
  try {
    return localStorage.getItem(ADMIN_JWT_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setAdminJwt(token) {
  try {
    if (token) localStorage.setItem(ADMIN_JWT_STORAGE_KEY, token);
    else localStorage.removeItem(ADMIN_JWT_STORAGE_KEY);
  } catch {
    // ignore
  }
}

export function clearAdminJwt() {
  setAdminJwt(null);
}

export function hasAdminSession() {
  try {
    if (typeof window === "undefined" || !window.localStorage) return false;
    const jwt = localStorage.getItem(ADMIN_JWT_STORAGE_KEY);
    if (typeof jwt === "string" && jwt.trim()) return true;
    return localStorage.getItem(ADMIN_AUTH_FLAG_KEY) === "true";
  } catch {
    return false;
  }
}
